<template>
    <div id="homeRoot">
        <div id="homeGrid">
            <router-link id="featuredCard" :to="'/feature/' + 0">
                <FeaturedCard/>
            </router-link>

<!--            <router-link id="normalCard" :to="'/feature/' + 0">-->
<!--                <NormalCard/>-->
<!--            </router-link>-->
        </div>
    </div>
</template>

<script>
	import FeaturedCard from "../components/FeaturedCard.vue";
	import NormalCard from "../components/NormalCard";

	export default {
    name: "Home",
		components: {
            // eslint-disable-next-line vue/no-unused-components
			NormalCard,
			FeaturedCard
		},
		created() {
			document.title = "OT";
		},
	};
</script>

<style lang="scss" src="../styles/home.scss" scoped/>
